/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { DashboardPageTodoListSectionViewerFragmentDoc } from './DashboardPageTodoListSection.generated';
import { DashboardPageNewsSectionNewsForPlannerFragmentDoc } from './DashboardPageNewsSection.generated';
import { SettingsPagePlannerSpecialtyFragmentDoc, SettingsPagePlannerFragmentDoc } from '../SettingsPage/SettingsPage.generated';
import { DashboardPageLineMessageSendingQuotaSectionFragmentDoc } from './DashboardPageLineMessageSendingQuotaSection.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type Plan =
  /** V2021_1 エンタープライズプラン */
  | 'V2021_1Enterprise'
  /** V2021_1 プレミアムプラン */
  | 'V2021_1Premium'
  /** V2021_1 スタンダードプラン */
  | 'V2021_1Standard'
  /** V2022_1 Enterpriseプラン */
  | 'V2022_1Enterprise'
  /** V2022_1 Entryプラン */
  | 'V2022_1Entry'
  /** V2022_1 PRプラン */
  | 'V2022_1PR'
  /** V2022_1 Proプラン */
  | 'V2022_1Pro'
  /** V2022_2 管理者専用無料プラン */
  | 'V2022_2ManageOnlyFree'
  /** V2023_1 エンタープライズプラン */
  | 'V2023_1Enterprise'
  /** V2023_1 エキスパートプラン */
  | 'V2023_1Expert'
  /** V2023_1 管理者専用無料プラン */
  | 'V2023_1ManageOnlyFree'
  /** V2023_1 マスタープラン */
  | 'V2023_1Master'
  /** V2023_1 スキルフォースプラン */
  | 'V2023_1SkillForce';

export type DashboardPageQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardPageQuery = { viewer: { hasLineActivationProvider: boolean, plan: Types.Plan, todoList: { showSeminar: boolean, showAutoKartePlannerCommentSetting: boolean, showWriteProfile: boolean } }, planner: { id: string, name: string, slug: string, avatar: any, avatarUrl: string, cover: any, coverUrl: string | null, corporationId: string, branchIds: Array<string>, email: string, gender: string, birthday: DateString | null, availableTime: string, availableAreaCodes: Array<string>, role: string, comment: string, authorities: Array<string>, specialties: Array<{ id: string, name: string }> } | null, specialties: Array<{ id: string, name: string }>, newsForPlanner: { edges: Array<{ node: { id: string, title: string, body: string, publishedAt: TimeString } }> } };

export type DashboardPageLineMessageSendingQuotaQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardPageLineMessageSendingQuotaQuery = { lineMessagingCurrentMonthQuota: { totalUsage: number, quota:
      | { __typename: 'LineMessagingCurrentMonthQuota_Limited', limit: number }
      | { __typename: 'LineMessagingCurrentMonthQuota_None', void: any }
     } };


export const DashboardPageDocument = gql`
    query DashboardPage {
  viewer {
    hasLineActivationProvider
    plan
    ...DashboardPageTodoListSectionViewer
  }
  ...DashboardPageNewsSectionNewsForPlanner
  planner {
    ...SettingsPagePlanner
  }
  specialties {
    ...SettingsPagePlannerSpecialty
  }
}
    ${DashboardPageTodoListSectionViewerFragmentDoc}
${DashboardPageNewsSectionNewsForPlannerFragmentDoc}
${SettingsPagePlannerFragmentDoc}
${SettingsPagePlannerSpecialtyFragmentDoc}`;

/**
 * __useDashboardPageQuery__
 *
 * To run a query within a Vue component, call `useDashboardPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDashboardPageQuery();
 */
export function useDashboardPageQuery(options: VueApolloComposable.UseQueryOptions<DashboardPageQuery, DashboardPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DashboardPageQuery, DashboardPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DashboardPageQuery, DashboardPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DashboardPageQuery, DashboardPageQueryVariables>(DashboardPageDocument, {}, options);
}
export function useDashboardPageLazyQuery(options: VueApolloComposable.UseQueryOptions<DashboardPageQuery, DashboardPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DashboardPageQuery, DashboardPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DashboardPageQuery, DashboardPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DashboardPageQuery, DashboardPageQueryVariables>(DashboardPageDocument, {}, options);
}
export type DashboardPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DashboardPageQuery, DashboardPageQueryVariables>;
export const DashboardPageLineMessageSendingQuotaDocument = gql`
    query DashboardPageLineMessageSendingQuota {
  ...DashboardPageLineMessageSendingQuotaSection
}
    ${DashboardPageLineMessageSendingQuotaSectionFragmentDoc}`;

/**
 * __useDashboardPageLineMessageSendingQuotaQuery__
 *
 * To run a query within a Vue component, call `useDashboardPageLineMessageSendingQuotaQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPageLineMessageSendingQuotaQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDashboardPageLineMessageSendingQuotaQuery();
 */
export function useDashboardPageLineMessageSendingQuotaQuery(options: VueApolloComposable.UseQueryOptions<DashboardPageLineMessageSendingQuotaQuery, DashboardPageLineMessageSendingQuotaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DashboardPageLineMessageSendingQuotaQuery, DashboardPageLineMessageSendingQuotaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DashboardPageLineMessageSendingQuotaQuery, DashboardPageLineMessageSendingQuotaQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DashboardPageLineMessageSendingQuotaQuery, DashboardPageLineMessageSendingQuotaQueryVariables>(DashboardPageLineMessageSendingQuotaDocument, {}, options);
}
export function useDashboardPageLineMessageSendingQuotaLazyQuery(options: VueApolloComposable.UseQueryOptions<DashboardPageLineMessageSendingQuotaQuery, DashboardPageLineMessageSendingQuotaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DashboardPageLineMessageSendingQuotaQuery, DashboardPageLineMessageSendingQuotaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DashboardPageLineMessageSendingQuotaQuery, DashboardPageLineMessageSendingQuotaQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DashboardPageLineMessageSendingQuotaQuery, DashboardPageLineMessageSendingQuotaQueryVariables>(DashboardPageLineMessageSendingQuotaDocument, {}, options);
}
export type DashboardPageLineMessageSendingQuotaQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DashboardPageLineMessageSendingQuotaQuery, DashboardPageLineMessageSendingQuotaQueryVariables>;